import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { epicsErrorHandler } from '../../epics'

import { saveLastSeenProductReleaseError, saveLastSeenProductReleaseSuccess } from './actions'
import { LAST_SEEN_PRODUCT_RELEASE_SAVE_ASYNC } from './constants'

const saveLastSeenProductReleaseEpic = (action$, store, { api }) =>
  action$.ofType(LAST_SEEN_PRODUCT_RELEASE_SAVE_ASYNC.INITIATE).mergeMap(() =>
    api.accounts
      .saveLastSeenProductRelease()
      .map(() => saveLastSeenProductReleaseSuccess())
      .catch((error) => Observable.of(epicsErrorHandler(saveLastSeenProductReleaseError, error)))
  )

export default combineEpics(saveLastSeenProductReleaseEpic)
